import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { EnvService } from '@src/app/modules/env';
import { UrlPipe } from '@src/app/shared/pipes';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class BaseMessageComponent {
  private readonly env = inject(EnvService);
  private readonly urlPipe = inject(UrlPipe);

  /** Тэг текущего компонента (см. selector) */
  abstract tagNameForExit: string;

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    this.processingLinkClick(target, event);
  }

  private processingLinkClick(el: HTMLElement, event: MouseEvent) {
    if (el.tagName.toLocaleLowerCase() === 'a') {
      event.preventDefault();
      event.stopPropagation();
      const url = el.getAttribute('href');
      if (url) {
        const normalizedUrl = this.urlPipe.transform(url) ?? '';
        this.env.openLink(normalizedUrl);
      }
    } else if (el.tagName.toLocaleLowerCase() === this.tagNameForExit.toLocaleLowerCase()) {
      return;
    } else {
      const parentElement = el.parentElement;
      if (parentElement) {
        this.processingLinkClick(parentElement, event);
      }
    }
  }
}
